import { render, staticRenderFns } from "./FissionShareTable.vue?vue&type=template&id=1905836e&scoped=true&"
import script from "./FissionShareTable.vue?vue&type=script&lang=js&"
export * from "./FissionShareTable.vue?vue&type=script&lang=js&"
import style0 from "./FissionShareTable.vue?vue&type=style&index=0&id=1905836e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1905836e",
  null
  
)

export default component.exports